import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Loading } from '../ui/Loading/Loading'
import { WipClientGroupWithClients, WipClientGroupWithJobTypes, WipData, WipJobWithTime } from '../../../../back-end/common/wip'
import { Check, ChevronDown, ChevronRight, Plus } from 'react-feather'
import './jobRow.css'
import { roundToTwo } from '../../utilities/format'

interface JobRowsProps {
	loading: boolean
	outstandingWip: WipData
	setSelectedJobs: (jobIDs: string[]) => void
	selectedJobs: string[]
	onClose?: () => void
}


const jobMap = (job: WipJobWithTime, props: JobRowsProps) => {
	const removeJob = () => {
		props.setSelectedJobs(
			props.selectedJobs.filter((e) => e !== job.jobID))
	}

	const addJob = () => {
		props.setSelectedJobs([
			...props.selectedJobs,
			job.jobID])
	}

	return (
		<Row key={job.jobID} className="py-2">
			<Col sm={2}></Col>
			<Col sm={7}>
				<span className="span-black span-body-2">{job.number + ' - ' + job.name}</span>
			</Col>
			<Col sm={2}>
				<span className="span-black span-body-2">{roundToTwo(job.timeItems.reduce((total, time) => (total += time.remainingDollars), 0))}</span>
			</Col>
			<Col sm={1}>
				<span className="span-black span-body-2">
					{
						props.selectedJobs.includes(job.jobID) ?
							<Check
								size={20}
								onClick={removeJob} /> :
							<Plus
								size={20}
								onClick={addJob}
							/>
					}
				</span>
			</Col>
		</Row>
	)
}

const JobRows = (props: JobRowsProps) => {
	const [expanded, setExpanded] = React.useState<Record<string, boolean>>({})

	if (props.loading) {
		return (
			<div className="center-flex p-5">
				<Loading show />
			</div>
		)
	}

	return (
		<>
			{props.outstandingWip.familyGroups.map((fg) => (
				<React.Fragment key={fg.clientGroupID}>
					{props.outstandingWip.grouping === 'fjcj' ? (
						<>
							{(fg as WipClientGroupWithJobTypes).jobTypes.map((jobType) => (
								<React.Fragment key={jobType.type}>
									<Row className="py-2 align-items-center job-row-highlighted">
										<Col sm={1} className="center-flex">
											{expanded[jobType.type || ''] ? (
												<ChevronDown size={20} onClick={() => setExpanded({ ...expanded, [jobType.type || '']: false })} />
											) : (
												<ChevronRight size={20} onClick={() => setExpanded({ ...expanded, [jobType.type || '']: true })} />
											)}
										</Col>
										<Col sm={11}>
											<span className="span-black span-body-2">{jobType.type}</span>
										</Col>
									</Row>
									<Row className="py-2">
										<Col></Col>
									</Row>
									{expanded[jobType.type || ''] &&
										jobType.clients.map((client) => (
											<React.Fragment key={client.clientID}>
												<Row>
													<Col sm={1}></Col>
													<Col sm={11}>
														<span className="span-black span-body-2">{client.name}</span>
													</Col>
												</Row>
												{client.jobs.map((job) => jobMap(job, props))}
											</React.Fragment>
										))}
								</React.Fragment>
							))}
						</>
					) : (
						<>
							{(fg as WipClientGroupWithClients).clients.map((client) => (
								<React.Fragment key={client.clientID}>
									<Row className="py-2 align-items-center job-row-highlighted">
										<Col sm={1} className="center-flex">
											{expanded[client.clientID] ? (
												<ChevronDown size={20} onClick={() => setExpanded({ ...expanded, [client.clientID || '']: false })} />
											) : (
												<ChevronRight size={20} onClick={() => setExpanded({ ...expanded, [client.clientID || '']: true })} />
											)}
										</Col>
										<Col sm={11}>
											<span className="span-black span-body-2">{client.name}</span>
										</Col>
									</Row>
									{expanded[client.clientID] && client.jobs.map((job) => jobMap(job, props))}
								</React.Fragment>
							))}
						</>
					)}
				</React.Fragment>
			))}
		</>
	)
}

export default JobRows
